module.exports = __webpack_public_path__ + "img/15_25.d27e19dd.png";